const rumEvents = {
  // page loads
  PERFORMANCE_NAVIGATION_EVENT: "com.amazon.rum.performance_navigation_event",

  // device connection and initialization
  CONNECT_DEVICE: "CONNECT_DEVICE",
  // INITIALIZE_DEVICE: "INITIALIZE_DEVICE",

  // fw update
  FIRMWARE_UPDATE: "FIRMWARE_UPDATE",
  FIRMWARE_UPDATE_DEVICE_RECONNECTION: "FIRMWARE_UPDATE_DEVICE_RECONNECTION",

  // advanced diagnostic
  ADVANCED_DIAGNOSTIC_COMPLETED: "ADVANCED_DIAGNOSTIC_COMPLETED",
  ADVANCED_DIAGNOSTIC_PROCESS: "ADVANCED_DIAGNOSTIC_PROCESS",

  // settings
  SETTINGS: "SETTINGS",

  // battery health
  BATTERY_HEALTH: "BATTERY_HEALTH"
};

export default rumEvents;
